export const isTokenExpired = () => {
   // debugger
    try {
      const tokenData = JSON.parse(localStorage.getItem('x_t'));
      if (!tokenData?.ed || !tokenData?.et) return true;
      const expiryDateTime = new Date(`${tokenData.ed}T${tokenData.et}`).getTime();
      const now = Date.now();
      return now > expiryDateTime;
    } catch {
      return true;
    }
  };
  